import CertificatesTabView from './components/certificates-tab-view/CertificatesTabView';

const CertificatesPage = (): JSX.Element => {
  return (
    <div className='px-3 py-4 sm:p-4 flex flex-column'>
      <CertificatesTabView />
    </div>
  );
};

export default CertificatesPage;
